import { EntityWithId } from 'src/types'
import {MensajePais, SistemaTipo} from "../../../types/enum/enum";

export const MensajeDetalleFields = {
    CodigoSistema: 'codSistema',
    NombreSistema: 'nombreSistema',
    CodigoSistemaPrincipal: 'codSistemaPrincipal',
    NombreSistemaPrincipal: 'nombreSistemaPrincipal',
    IdEtapaActual: 'idEtapaActual',
    CodSistemaTipo: 'codSistemaTipo',
    IdOperacion: 'idOperacion',
    FechaIngresoEtapa: 'fechaIngresoEtapa',
    FechaCreacion: 'fechaCreacion',
    NombreEtapaActual: 'nombreEtapaActual',
    Referencia: 'referencia',
    DiasEnEtapa: 'diasEnEtapa',
    CodEtapaEstado: 'codEtapaEstado',
    DescEtapaEstado: 'descEtapaEstado',
    HexColor: 'hexColor',
    PermisoTipo: 'permisoTipo'
} as const

export type MensajeDetalle = EntityWithId & {
    [MensajeDetalleFields.CodigoSistema]: number
    [MensajeDetalleFields.NombreSistema]: string
    [MensajeDetalleFields.CodigoSistemaPrincipal]: MensajePais
    [MensajeDetalleFields.NombreSistemaPrincipal]: string
    [MensajeDetalleFields.IdEtapaActual]: number
    [MensajeDetalleFields.CodSistemaTipo]: SistemaTipo
    [MensajeDetalleFields.IdOperacion]: number
    [MensajeDetalleFields.FechaIngresoEtapa]: string
    [MensajeDetalleFields.FechaCreacion]: string
    [MensajeDetalleFields.NombreEtapaActual]: string
    [MensajeDetalleFields.Referencia]: string
    [MensajeDetalleFields.DiasEnEtapa]: number
    [MensajeDetalleFields.CodEtapaEstado]: number
    [MensajeDetalleFields.DescEtapaEstado]: string
    [MensajeDetalleFields.HexColor]: string
    [MensajeDetalleFields.PermisoTipo]: number
}
